const BOOKING_STATUS_COPY_BY_TYPE = {
  INQUIRY_CONVERTED: {
    badge: 'Neue Anfrage',
    message: 'Neue Anfrage',
  },
  BOOKING_CREATED: {
    badge: 'Neue Anfrage',
    message: 'Neue Anfrage',
  },
  BOOKING_CONFIRMED: {
    badge: 'Anfrage bestätigt',
    message: 'Anfrage bestätigt',
  },
  BOOKING_DECLINED: {
    badge: 'Anfrage abgelehnt',
    message: 'Anfrage abgelehnt',
  },
  BOOKING_CANCELLED: {
    badge: 'Buchung storniert',
    message: 'Buchung storniert',
  },
  BOOKING_WITHDRAWN: {
    badge: 'Anfrage wurde zurückgezogen',
    message: 'Anfrage wurde zurückgezogen',
  },
  BOOKING_EXPIRED: {
    badge: 'Anfrage ist abgelaufen',
    message: 'Anfrage ist abgelaufen',
  },
  BOOKING_COMPLETED: {
    badge: 'Buchung abgeschlossen',
    message: 'Buchung abgeschlossen',
  },
  BOOKING_NO_SHOW: {
    badge: 'Nicht erschienen',
    message: 'Nicht erschienen',
  },
};

const getLastMessageType = (conversation) =>
  conversation?.lastMessage?.type || conversation?.lastMessageType || null;

const getLastMessageSenderID = (conversation) =>
  conversation?.lastMessage?.senderID || conversation?.lastMessageSenderID || null;

const getLastMessageContent = (conversation) =>
  conversation?.lastMessage?.content || conversation?.lastMessageContent || '';

const hasBookingContext = (conversation) =>
  Boolean(conversation?.isBookingRelated || conversation?.linkedBookingID);

const canUseLegacySystemKeywordFallback = (conversation) => {
  const messageType = getLastMessageType(conversation);
  const senderID = getLastMessageSenderID(conversation);

  if (senderID !== 'SYSTEM') {
    return false;
  }

  return !messageType || messageType === 'SYSTEM';
};

const getKeywordStatus = (content) => {
  const normalizedContent = content.toLowerCase();

  if (normalizedContent.includes('abgelaufen') || normalizedContent.includes('expired')) {
    return BOOKING_STATUS_COPY_BY_TYPE.BOOKING_EXPIRED;
  }

  if (
    normalizedContent.includes('buchung erstellt') ||
    normalizedContent.includes('anfrage gesendet')
  ) {
    return BOOKING_STATUS_COPY_BY_TYPE.BOOKING_CREATED;
  }

  if (normalizedContent.includes('zurückgezogen') || normalizedContent.includes('withdrawn')) {
    return BOOKING_STATUS_COPY_BY_TYPE.BOOKING_WITHDRAWN;
  }

  if (
    normalizedContent.includes('abgelehnt') ||
    normalizedContent.includes('declined') ||
    normalizedContent.includes('rejected')
  ) {
    return BOOKING_STATUS_COPY_BY_TYPE.BOOKING_DECLINED;
  }

  if (normalizedContent.includes('bestätigt') || normalizedContent.includes('confirmed')) {
    return BOOKING_STATUS_COPY_BY_TYPE.BOOKING_CONFIRMED;
  }

  if (normalizedContent.includes('storniert') || normalizedContent.includes('cancelled')) {
    return BOOKING_STATUS_COPY_BY_TYPE.BOOKING_CANCELLED;
  }

  if (normalizedContent.includes('abgeschlossen') || normalizedContent.includes('completed')) {
    return BOOKING_STATUS_COPY_BY_TYPE.BOOKING_COMPLETED;
  }

  if (normalizedContent.includes('nicht erschienen') || normalizedContent.includes('no show')) {
    return BOOKING_STATUS_COPY_BY_TYPE.BOOKING_NO_SHOW;
  }

  return null;
};

const getGuestFirstName = (conversation) =>
  conversation?.guest?.firstName || conversation?.chatPartner?.firstName || '';

export const getConversationStatusBadge = (conversation) => {
  if (!hasBookingContext(conversation)) {
    return null;
  }

  const messageType = getLastMessageType(conversation);
  const typedStatus = BOOKING_STATUS_COPY_BY_TYPE[messageType];
  if (typedStatus) {
    return typedStatus.badge;
  }

  if (messageType === 'TEXT') {
    return null;
  }

  const messageContent = getLastMessageContent(conversation);
  const hasMessageContent = messageContent.trim() !== '';
  if (!hasMessageContent) {
    return 'Neue Anfrage';
  }

  if (!canUseLegacySystemKeywordFallback(conversation)) {
    return null;
  }

  return getKeywordStatus(messageContent)?.badge || null;
};

export const getConversationStatusMessage = (conversation) => {
  if (!hasBookingContext(conversation)) {
    return null;
  }

  const messageType = getLastMessageType(conversation);
  const typedStatus = BOOKING_STATUS_COPY_BY_TYPE[messageType];
  if (typedStatus) {
    if (messageType === 'BOOKING_WITHDRAWN') {
      const guestName = getGuestFirstName(conversation);
      return guestName
        ? `${guestName} hat die Anfrage zurückgezogen`
        : typedStatus.message;
    }
    return typedStatus.message;
  }

  if (messageType === 'TEXT') {
    return null;
  }

  const messageContent = getLastMessageContent(conversation);
  const hasMessageContent = messageContent.trim() !== '';
  if (!hasMessageContent) {
    return 'Neue Anfrage';
  }

  if (!canUseLegacySystemKeywordFallback(conversation)) {
    return null;
  }

  const keywordStatus = getKeywordStatus(messageContent);
  if (keywordStatus === BOOKING_STATUS_COPY_BY_TYPE.BOOKING_WITHDRAWN) {
    const guestName = getGuestFirstName(conversation);
    return guestName
      ? `${guestName} hat die Anfrage zurückgezogen`
      : keywordStatus.message;
  }

  return keywordStatus?.message || null;
};
